export default theme => ({

  content: {
    marginTop: theme.spacing.unit * 8
  },

  textField: {
    width: '100%',
  }

});




// WEBPACK FOOTER //
// ./src/styles/components/SearchDialog.js